export default {
  "World Heritage Organization": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Welterbe<br>Organisation"])},
  "World Heritage Visitor Center": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Welterbe<br>Besucherzentrum"])},
  "World Heritage Experience": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Welterbe<br>erleben"])},
  "World Heritage virtual": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Welterbe<br>virtuell"])}
}